<div class="pop-inputs pop-datatable pop-datatable-simple pop-class-modal">
  <div class="dialog-title"
       translate="TOOLBAR.CLASS">
  </div>
  <div *ngIf="rows"
       class="body">
    <p-table #classTable
             [globalFilterFields]="['code', 'description']"
             [value]="rows"
             [scrollable]="true"
             scrollHeight="flex">
      <!-- search -->
      <ng-template pTemplate="caption">
        <div class="pop-display-flex class-search-box">
          <i class="far fa-search"></i>
          <input type="text"
                 pInputText
                 size="50"
                 (input)="filterTable(classTable, $event.target)"
                 class="input-filter" />
        </div>
      </ng-template>
      <!-- header -->
      <ng-template pTemplate="header">
        <tr>
          <th class="checkbox-column"></th>
          <th class="code-column"
              translate="MODAL.CODE"></th>
          <th translate="MODAL.DESC"></th>
        </tr>
      </ng-template>
      <!-- rows -->
      <ng-template pTemplate="body"
                   let-row
                   let-editing="editing"
                   let-rowIndex="rowIndex">
        <tr [pSelectableRow]="row"
            [pEditableRow]="row">
          <td class="checkbox-column"
              [class.read-only]="!isStatusTypeNew || isGroupApproved">
            <div (click)="toggleClassification($event, row)">
              <pop-checkbox [isChecked]="row.classificationEstimate">
              </pop-checkbox>
            </div>
          </td>
          <td>
            {{ row.code }}
          </td>
          <td>
            {{ row.description }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
